// extracted by css-extract-rspack-plugin
export default {"svg":"Mtu4td","path":"wCiL76"};